export default __webpack_public_path__ + "static/media/sports22.bbc7965b.jpg";